export default __webpack_public_path__ + "static/media/banner_bg_mobile_md.4bd8be5e.svg";